var autoCompleteArray = {};
var address_format = { subpremise: 'long_name', street_number: 'short_name', route: 'long_name', locality: 'long_name', administrative_area_level_1: 'long_name', administrative_area_level_2: 'long_name', country: 'long_name', postal_code: 'short_name', postal_code_suffix: 'short_name', postal_town: 'long_name', postal_code_prefix: 'long_name' };
function initializeAddressAutocomplete(container) {
    var $container = container ? $(container) : $(document);

    if (typeof google === "undefined" || !google.maps || !google.maps.places) {
        return;
    }

    $container.find(".autocomplete").each(function () {
        var thisID = $(this).attr("id");
        if (!thisID || autoCompleteArray[thisID]) {
            return;
        }

        autoCompleteArray[thisID] = new google.maps.places.Autocomplete($(this)[0], {
            types: ['geocode'],
            fields: ['address_components'],
        });
        google.maps.event.addListener(autoCompleteArray[thisID], 'place_changed', function () {
            var place = autoCompleteArray[thisID].getPlace();
            if (place == null)
                return;
            var addressContainer = $("#" + thisID).parents(".address-block");
            for (var i = 0; i < place.address_components.length; i++) {
                var segmentType = place.address_components[i].types[0];
                if (typeof address_format[segmentType] !== 'undefined') {
                    var segmentVal = place.address_components[i][address_format[segmentType]];
                    if (segmentType == "street_number")
                        addressContainer.find("[id$=" + thisID + "]").val(segmentVal);
                    else if (segmentType == "subpremise")
                        addressContainer.find("[id$=Address2]").val(segmentVal);
                    else if (segmentType == "route")
                        addressContainer.find("[id$=" + thisID + "]").val(addressContainer.find("[id$=" + thisID + "]").val() + " " + segmentVal);
                    else if (segmentType == "locality" || segmentType == "postal_town")
                        addressContainer.find("[id$=City]").val(segmentVal);
                    else if (segmentType == "administrative_area_level_1")
                        addressContainer.find("[id$=StateProvince]").val(segmentVal);
                    else if (segmentType == "country")
                        addressContainer.find("[id$=CountryFullName]").val(segmentVal);
                    else if (segmentType == "postal_code" || segmentType == 'postal_code_prefix')
                        addressContainer.find("[id$=ZipCode]").val(segmentVal);
                    else if (segmentType == "postal_code_suffix")
                        addressContainer.find("[id$=ZipCode]").val(addressContainer.find("[id$=ZipCode]").val() + "-" + segmentVal);
                    else if (segmentType == "administrative_area_level_2" && $("[data-county-for=" + thisID + "]").length > 0) {
                        var countyElement = $("[data-county-for=" + thisID + "]");
                        var countyValue = segmentVal.replace(/ County$/i, "");
                        if (countyElement.hasClass("selectized")) {
                            countyElement[0].selectize.createItem(countyValue, true);
                            var timeout = setTimeout(function () {
                                countyElement[0].selectize.setValue(countyValue, true);
                                clearTimeout(timeout);
                            }, 500);
                        }
                        else
                            countyElement.val(countyValue);
                    }
                }
            }
            addressContainer.find("input,select").trigger("change");
        });

        $(this).focus(function () {
            $(this).attr("autocomplete", "nope");
        });
    });
}

function initAutocomplete() {
    $(function () {
        initializeAddressAutocomplete(document);
    });
}

function gm_authFailure() {
    ShowCustomAlert("Google Maps is not currently configured for " + window.location.hostname + ". Please contact the Novi support team if the problem continues.");
}